import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './OfferAndDealSearch.css';
import React, { useRef, useState, useEffect, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { ReactComponent as SearchIcon } from "../../../resources/icons/search-v1.svg";
import { ReactComponent as ClearIcon } from "../../../resources/icons/close.svg";
import { canUseDOM } from '../../../utils';
import { addQueryString, deleteQueryString } from '../../Listing/index';
import { TEXT_SEARCH_FACET_NAME } from '../ListingOffersAndDeals';
import { HighlighterHOC } from '../../atoms/HighlighterHOC/HighlighterHOC';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../utils/tealium';
var commonStyles = "ckqtnfu";
var ltrStyles = "l1xgcaiy";
var rtlStyles = "r1613089";
var SuggestionsList = function SuggestionsList(_ref) {
  var suggestionList = _ref.suggestionList,
    resultsTitle = _ref.resultsTitle,
    resultsForText = _ref.resultsForText,
    searchString = _ref.searchString,
    requestedString = _ref.requestedString,
    sendRequestHandler = _ref.sendRequestHandler,
    resultsNumber = _ref.resultsNumber,
    eventsAnalytics = _ref.eventsAnalytics,
    params = _ref.params;
  var drop = useRef(null);
  var list = useRef(null);
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    scrollable = _React$useState2[0],
    setScrollable = _React$useState2[1];
  var handleItemClick = function handleItemClick(title) {
    sendRequestHandler(title);
  };
  var resultsString = useMemo(function () {
    if (requestedString) {
      var splitted = resultsForText.replace('{N}', resultsNumber).split('{S}');
      var result = /*#__PURE__*/React.createElement(React.Fragment, null, splitted[0], /*#__PURE__*/React.createElement("span", {
        className: "suggestions-list-total__string"
      }, requestedString), splitted[1]);
      return result;
    }
    return null;
  }, [resultsForText, resultsNumber, requestedString]);
  useEffect(function () {
    if (list.current && list.current.offsetHeight > 300) {
      setScrollable(true);
    } else {
      setScrollable(false);
    }
  }, [suggestionList]);
  return /*#__PURE__*/React.createElement("div", {
    className: "suggestions-list-wrapper",
    ref: drop
  }, /*#__PURE__*/React.createElement("div", {
    className: " row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-9 col-xl-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "suggestions-list-block"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "suggestions-list-header"
  }, resultsTitle), /*#__PURE__*/React.createElement("div", {
    className: "".concat(scrollable ? 'suggestions-list-shadows--active' : '', " suggestions-list-shadows")
  }, /*#__PURE__*/React.createElement("div", {
    className: "suggestions-list-scroll-scrollable"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "suggestions-list autocomplete ",
    ref: list
  }, suggestionList.map(function (suggestion) {
    return /*#__PURE__*/React.createElement("li", {
      className: "suggestion-item",
      key: suggestion,
      onClick: function onClick() {
        handleItemClick(suggestion);
        tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['suggestedSearchAnalytics'], params), suggestion);
      }
    }, /*#__PURE__*/React.createElement(HighlighterHOC, {
      text: suggestion,
      searchString: searchString
    }));
  })))), /*#__PURE__*/React.createElement("div", {
    className: "suggestions-list-total"
  }, resultsString)))));
};
var OfferAndDealSearch = function OfferAndDealSearch(_ref2) {
  var rtl = _ref2.rtl,
    searchValue = _ref2.searchValue,
    setSearchValue = _ref2.setSearchValue,
    placeholder = _ref2.placeholder,
    resultsTitle = _ref2.resultsTitle,
    resultsForText = _ref2.resultsForText,
    setListingFilter = _ref2.setListingFilter,
    mostSearchedValues = _ref2.mostSearchedValues,
    resultsNumber = _ref2.resultsNumber,
    eventsAnalytics = _ref2.eventsAnalytics,
    params = _ref2.params;
  var history = useHistory();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    highLightText = _useState4[0],
    setHighLightText = _useState4[1];
  var _useState5 = useState(searchValue),
    _useState6 = _slicedToArray(_useState5, 2),
    value = _useState6[0],
    setValue = _useState6[1];
  var clickedTextRef = useRef(false);
  var fieldOpenedRef = useRef(null);
  var handleTextBlur = function handleTextBlur() {
    clickedTextRef.current = false;
    setHighLightText(false);
  };
  var handleTextMousedown = function handleTextMousedown() {
    clickedTextRef.current = true;
  };
  var handleTextFocus = function handleTextFocus() {
    setIsOpen(true);
    if (!clickedTextRef.current) {
      setHighLightText(true);
    }
  };
  var handleTextInput = function handleTextInput(e) {
    setIsOpen(true);
    var target = e.target;
    setValue(target.value);
  };
  var handleCloseClick = function handleCloseClick() {
    setValue('');
    if (searchValue) {
      setSearchValue('');
      deleteQueryString(TEXT_SEARCH_FACET_NAME, history);
      setListingFilter();
    }
  };
  var handleKeyPress = function handleKeyPress(event) {
    if ((event.key === 'Enter' || event.key === 'NumpadEnter') && value.trim() !== searchValue.trim()) {
      sendRequestHandler(value);
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['searchButtonAnalytics'], params), value);
    }
  };
  var handleGoClick = function handleGoClick() {
    sendRequestHandler(value);
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['searchButtonAnalytics'], params), value);
  };
  var sendRequestHandler = function sendRequestHandler(title) {
    setIsOpen(false);
    setValue(title);
    setSearchValue(title);
    addQueryString(TEXT_SEARCH_FACET_NAME, title, history);
    setListingFilter();
  };
  var hideDD = function hideDD(e) {
    if (fieldOpenedRef.current) {
      var mobileDevice = window.matchMedia("(max-width: 991px)").matches;
      if (e.type === 'scroll') {
        if (mobileDevice) return;
      }
      if (e.type === 'click') {
        if (mobileDevice || e.target.closest('.input-search-box') || e.target.closest('.suggestions-list-block')) return;
      }
      setIsOpen(false);
    }
  };
  useEffect(function () {
    fieldOpenedRef.current = isOpen;
  }, [isOpen]);
  useEffect(function () {
    if (canUseDOM) {
      window.addEventListener('scroll', hideDD);
      document.addEventListener("click", hideDD);
    }
    return function () {
      if (canUseDOM) {
        window.removeEventListener('scroll', hideDD);
        document.removeEventListener("click", hideDD);
      }
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, isOpen && /*#__PURE__*/React.createElement(SuggestionsList, {
    suggestionList: mostSearchedValues,
    resultsTitle: resultsTitle,
    resultsForText: resultsForText,
    searchString: value,
    requestedString: searchValue,
    sendRequestHandler: sendRequestHandler,
    resultsNumber: resultsNumber,
    eventsAnalytics: eventsAnalytics,
    params: params
  }), /*#__PURE__*/React.createElement("div", {
    className: "input-search-box"
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    className: "\n          input-text-primary\n          input-search-text\n          ".concat(highLightText ? 'input-text-primary--focused' : '', "\n          ").concat(isOpen ? 'input-search-text--opened-drop' : '', "\n        "),
    placeholder: placeholder,
    onClick: function onClick() {
      return setIsOpen(true);
    },
    onKeyPress: handleKeyPress,
    onMouseDown: handleTextMousedown,
    onFocus: handleTextFocus,
    onBlur: handleTextBlur,
    onChange: handleTextInput,
    value: value
  }), /*#__PURE__*/React.createElement("button", {
    disabled: !value.trim().length,
    onClick: handleGoClick,
    className: "btn-link search-icon"
  }, /*#__PURE__*/React.createElement(SearchIcon, null)), !!value.trim().length && /*#__PURE__*/React.createElement("button", {
    onClick: handleCloseClick,
    className: "btn-link close-icon"
  }, /*#__PURE__*/React.createElement(ClearIcon, null))));
};
export default OfferAndDealSearch;